import { Paper, ThemeProvider } from '@mui/material';
import { ConfirmOptions } from 'material-ui-confirm';
import { ToastOptions } from 'react-toastify';

import { lightTheme } from '../theme';

export const env = (import.meta.env.VITE_ENV_NAME as 'prod' | 'dev') || 'dev';

export enum Locales {
    'en' = 'en',
    'fr' = 'fr',
}
export const defaultLocale = Locales.en;

export const ONE_HOUR = 60 * 60 * 1000;

export const errorToastConfig: ToastOptions = {
    autoClose: 6000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'error' as const,
};

export const successToastConfig: ToastOptions = {
    autoClose: 4000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'success' as const,
};

export const infoToastConfig: ToastOptions = {
    autoClose: 3000,
    hideProgressBar: true,
    pauseOnHover: true,
    closeButton: false,
    closeOnClick: true,
    type: 'info' as const,
    toastId: 'info',
};

export const defaultConfirmProps: ConfirmOptions = {
    dialogProps: {
        disablePortal: true,
        PaperComponent: props => (
            <ThemeProvider theme={lightTheme}>
                <Paper {...props} />
            </ThemeProvider>
        ),
    },
    cancellationButtonProps: {
        color: 'primary',
        variant: 'contained',
        size: 'small',
    },
    confirmationButtonProps: {
        color: 'primary',
        variant: 'contained',
        size: 'small',
    },
};
